import React, { FC } from 'react';
import { Box } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import AppHeader from './components/AppHeader/AppHeader';

interface HeaderProps {
    isUserAdmin: boolean;
}

const Header: FC<HeaderProps> = ({ isUserAdmin }) => (
    <Box data-testid="header" className="background-color-l" sx={{ height: '84px' }}>
        <Routes>
            <Route path="/admin" element={<AppHeader />} />
            <Route path={`/download-report`} element={<></>} />
            <Route path="/*" element={<AppHeader />} />
        </Routes>
    </Box>
);

export default Header;
